import { Flex, Button } from 'antd';

const FilterActionsComponent = ({ onCleanFilters }) => {
    return (
        <>
            <Flex gap="middle" align="end" vertical>
                <Flex align={"flex-end"}>
                    <Button type="default" onClick={onCleanFilters}>
                        Limpiar filtros
                    </Button>
                </Flex>
            </Flex>
        </>
    )
}

export default FilterActionsComponent;